import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { BaseService } from "../../_shared/services/base.service";
import { PersonListFilterFields } from "../../person/models/person-filter-fields";

import { Login, User } from "../models/user";
import { UserCreateModel } from "../models/userCreateModel";
import { UserEditModel } from "../models/user-edit.model";
import { UserOrganizationList } from "../models/userOrganization";
import { PersonNameAndAddressDto, PersonWithContact } from "../../person/models/person";

@Injectable({
  providedIn: "root",
})
export class UserService extends BaseService<Login, User> {
  constructor(
    protected override http: HttpClient,
    @Inject("BASE_URL") protected override baseUrl: string
  ) {
    super(http, baseUrl, "user");
  }

  login(user: Login) {
    return this.http
      .post(this.baseUrl + this.controller + "/signin", user, {
        observe: "response",
      })
      .pipe(
        map((resp: any) => {
          var auth = resp.headers.get("X-Token");
          if (auth) localStorage.setItem("accessKey", auth.toString());
        })
      );
  }

  hasMfa(user: Login): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + this.controller + "/HasMFA", user);
  }

  getCurrent(): Observable<User> {
    return this.get<User>("/current");
  }

  isSignedIn(): Observable<boolean> {
    return this.get<boolean>("/signedin");
  }

  create(organizationId: number, model: UserCreateModel) {
    return this.post("/create?organizationId=" + organizationId, model);
  }

  createBulk(filters: PersonListFilterFields, organizationId: number): Observable<number | null> {
    filters.disablePaging();
    return this.get(
      "/CreateBulk?organizationId=" +
      organizationId +
      "&" +
      this.serializeForQueryStringOdata(filters)
    );
  }

  getUserOrganizations(): Observable<UserOrganizationList[]> {
    return this.get("/getUserOrganizations");
  }

  loginAs(org: UserOrganizationList): Observable<UserOrganizationList[]> {
    return this.get("/loginAs/" + org.Id + "?redirectUrl=''");
  }

  getUsersPersonData() {
    return this.getAll<PersonNameAndAddressDto>("/personData");
  }

  updateAccount(model: UserEditModel): Observable<any> {
    return this.http.put(this.baseUrl + this.controller, model);
  }
}
